// @flow
import {CommonActions} from '@react-navigation/native';
import {connect} from 'react-redux';
import {isLineOFFSelector, touchPlanFrame} from '../../../modules/Dashboard';
import {voucherComeFromSelector} from '../../../modules/Voucher';
import {setCurrentVoucherDetails} from '../../../modules/Voucher/actions';
import VoucherDetails from './VoucherDetails';
import {goToSignUp} from '../../../modules/Navigation/actions';
import * as Navigation from '../../../lib/navigation.js';
import WizzeeLog from '../../../lib/wizzeeLog';

const mapStateToProps = state => ({
  comeFrom: voucherComeFromSelector(state),
  isLineOFF: isLineOFFSelector(state),
});

const mapDispatchToProps = (dispatch: Function) => ({
  setCurrentVoucherDetails: (object: Object) =>
    dispatch(setCurrentVoucherDetails(object)),
  goToPreviousScreen: (
    comeFrom: string,
    isLineOFF: Boolean,
    voucherDetails: Object,
  ) => goToProperRoute(dispatch, comeFrom, isLineOFF, voucherDetails),
});

const goToProperRoute = (
  dispatch: Function,
  comeFrom: string,
  isLineOFF: Boolean,
  voucherDetails: Object,
) => {
  WizzeeLog.log('>>> goToProperRoute() - comeFrom', comeFrom);
  switch (comeFrom) {
    case 'topup':
      Navigation.navigate('international');
      break;

    case 'delivery':
    case 'subscription':
    case 'signup':
      dispatch(goToSignUp());
      break;

    case 'activation':
      Navigation.navigate('simCardManual');
      break;

    case 'changeplan':
      Navigation.resetToPath('changePlan');
      break;

    case 'menu':
    case 'dashboard':
      const voucherCategory = getVoucherCategory(voucherDetails);

      if (isVoucherCategoryActivation(voucherCategory)) {
        Navigation.navigate('simCardManual');
      } else if (isVoucherCategorySignUp(voucherCategory)) {
        dispatch(goToSignUp());
      } else if (isVoucherCategoryTopUp(voucherCategory)) {
        Navigation.navigate('international');
      } else {
        dispatch(touchPlanFrame());
      }
      break;

    case 'confirmplan':
      Navigation.navigate('confirmPlan');
      break;

    case 'confirmplanduringactivate':
      Navigation.navigate('confirmPlanDuringActivate');
      break;

    case 'chooseinternationaloptions':
      Navigation.navigate('chooseInternationalOptions');
      break;

    case 'traveltopup':
      Navigation.navigate('travelTopUp');
      break;

    case 'chooseplan':
      Navigation.navigate('choosePlan');
      break;

    case 'booster':
      Navigation.navigate('topUp');
      break;

    default:
      WizzeeLog.log('Valeur comeFrom inconue:', comeFrom);
      break;
  }
};

const getVoucherCategory = (voucherDetails: Object): string => {
  return voucherDetails.characteristics.ORDER_CATEGORY_RESTRICTED;
};

const isVoucherCategoryActivation = (voucherOrderCategory: string): Boolean => {
  return voucherOrderCategory === 'ACTIVATION';
};

const isVoucherCategorySignUp = (voucherOrderCategory: string): Boolean => {
  return (
    voucherOrderCategory === 'SIGNUP' ||
    voucherOrderCategory === 'SUBSCRIPTION' ||
    voucherOrderCategory === 'DELIVERY'
  );
};
const isVoucherCategoryTopUp = (voucherOrderCategory: string): Boolean => {
  return voucherOrderCategory === 'TOPUP';
};

const navigateBackFromVoucherDetails = newRoutes => {
  Navigation.dispatch(state => {
    const routes = state.routes.slice(0, -2);
    if (newRoutes != null) {
      routes.push(...newRoutes);
    }
    return CommonActions.reset({
      ...state,
      routes,
      index: routes.length - 1,
    });
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherDetails);
